module.exports = __webpack_public_path__ + "img/banner.30c270c8.png";